export const STAGING_QUESTIONNAIRE_API_ORIGIN = 'https://getborg-questionnaire-staging.searchatlas.workers.dev'
export const STAGING_QUESTIONNAIRE_API_URL = `${STAGING_QUESTIONNAIRE_API_ORIGIN}/api/questionnaire`
export const STAGING_QUESTIONNAIRE_SITE_ORIGIN = 'https://staging.getborg.com'

export function questionnaireApiUrl(configuredUrl: unknown, siteUrl: unknown, browserOrigin: string): string | null {
  if (!configuredUrl) return '/api/questionnaire'
  return configuredUrl === STAGING_QUESTIONNAIRE_API_URL && siteUrl === STAGING_QUESTIONNAIRE_SITE_ORIGIN && browserOrigin === STAGING_QUESTIONNAIRE_SITE_ORIGIN
    ? STAGING_QUESTIONNAIRE_API_URL : null
}
